import {FilterMetadataMap, FromFilterDefinition, NonNullableFilterValues, NullableFilterValues,} from "../filtering";
import {SortSelectionObject} from "../common";

export const LIFT_SORT_COLUMNS = {
    status: 'status',
    startDate: 'startDate',
    endDate: 'endDate'
} as const;

export const LIFT_DEFAULT_SORT: SortSelectionObject<typeof LIFT_SORT_COLUMNS> = {column: 'endDate', direction: 'desc'}

export const LIFT_FILTER_DEFINITION = {
    search: 'string',
    startDate: 'DateFilter',
    endDate: 'DateFilter',
    status: 'string[]',
    jobSite: 'string[]',
    city: 'string[]',
    state: 'string[]'
} as const;

export const LIFT_STATUS_VALUES = [
    'Requested',
    'Scheduled',
    'Open',
    'Terminated',
    'Cancelled',
] as const;

export const LIFT_FILTER_METADATA = {
    status: {
        kind: 'enum' as const,
        enumValues: LIFT_STATUS_VALUES,
        isArray: true,
    },
} as const satisfies FilterMetadataMap<typeof LIFT_FILTER_DEFINITION>;

export type LiftFilterDefinition = FromFilterDefinition<typeof LIFT_FILTER_DEFINITION>

export type NullableLiftFilter = NullableFilterValues<LiftFilterDefinition>;
export type NonNullableLiftFilter =
    NonNullableFilterValues<LiftFilterDefinition>;

export const DEFAULT_LIFT_FILTER: NullableLiftFilter = {
    search: null,
    startDate: null,
    endDate: null,
    status: null,
    jobSite: null,
    city: null,
    state: null,
};
